import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
// import { isEqual } from "lodash";
import { DateTime } from 'luxon/src/luxon';

export const useCasiolaStore = defineStore('casiola', () => {

  function isEqual (obj1, obj2) {

    /**
     * More accurately check the type of a JavaScript object
     * @param  {Object} obj The object
     * @return {String}     The object type
     */
    function getType (obj) {
      return Object.prototype.toString.call(obj).slice(8, -1).toLowerCase();
    }
  
    function areArraysEqual () {
  
      // Check length
      if (obj1.length !== obj2.length) return false;
  
      // Check each item in the array
      for (let i = 0; i < obj1.length; i++) {
        if (!isEqual(obj1[i], obj2[i])) return false;
      }
  
      // If no errors, return true
      return true;
  
    }
  
    function areObjectsEqual () {
  
      if (Object.keys(obj1).length !== Object.keys(obj2).length) return false;
  
      // Check each item in the object
      for (let key in obj1) {
        if (Object.prototype.hasOwnProperty.call(obj1, key)) {
          if (!isEqual(obj1[key], obj2[key])) return false;
        }
      }
  
      // If no errors, return true
      return true;
  
    }
  
    function areFunctionsEqual () {
      return obj1.toString() === obj2.toString();
    }
  
    function arePrimativesEqual () {
      return obj1 === obj2;
    }
  
    // Get the object type
    let type = getType(obj1);
  
    // If the two items are not the same type, return false
    if (type !== getType(obj2)) return false;
  
    // Compare based on type
    if (type === 'array') return areArraysEqual();
    if (type === 'object') return areObjectsEqual();
    if (type === 'function') return areFunctionsEqual();
    return arePrimativesEqual();
  
  }

  const today = DateTime.utc()
  
  const state = ref({
    selectedUnit: window.unit || null,
    selectedQuote: window.quote || null,
    booking_firstName: null,
    booking_lastName: null,
    booking_email: null,
    booking_work: false,
    booking_street: null,
    booking_city: null,
    booking_zip: null,
    booking_state: null,
    booking_country: null,
    cc_name: null,
    cc_no: null,
    cc_valid: null,
    cc_cvc: null,
    search: {
      mobileSearch: null,
      enforceFlow: true,
      showSort: false,
      showFilters: false,
      modal: null,
      display: null
    },
    mobileBooker: null,
    mobileBookerSearch: null,
    sort: {
      id: null,
      dir: null
    },
    baseFilters: {
      destinations: window.destinationId ? [window.destinationId] : [],
      destinationKey: window.destinationKey ? window.destinationKey : null,
      date: {
        start: null,
        end: null
      },
      guests: {
        adults: 0,
        children: 0,
        pets: 0
      }
    },
    advancedFilters: {
      area: null,
      petFriendly: null,
      privatePool: null,
      pool: null,
      lodgingTypeIds: [],
      locationIds: [],
      // beds: 1,
      minimumBeds: 1,
      maximumBeds: null,
      // bedrooms: 0,
      minimumBedrooms: 1,
      maximumBedrooms: null,
      // bathrooms: 1,
      minimumBathrooms: 1,
      maximumBathrooms: null,
      nightlyRate: null,
      deal: null,
      new: null,
      amenityIds: [],
      amenityKeys: []
    },
    map: {
      searchArea: true,
      suspendSearch: true
    },
    collections: {
      destinations: [],
      locations: [],
      lodgingTypes: []
    },
    results: {
      total: 0
    },
    ccalendar: {
      year: today.year,
      month: today.month,
      monthDetails: []
    }
  })
  watch(() => state.value.baseFilters.guests.pets, (pets) => {
    if (pets) {
      state.value.advancedFilters.petFriendly = true
    }
  })
  // watch(() => state.value.advancedFilters.beds, (beds) => {
  //   if (beds) {
  //     state.value.advancedFilters.minimumBeds = beds
  //     state.value.advancedFilters.maximumBeds = null
  //   } else {
  //     state.value.advancedFilters.minimumBeds = null
  //   }
  // })
  // watch(() => state.value.advancedFilters.bedrooms, (bedrooms) => {
  //   if (bedrooms) {
  //     state.value.advancedFilters.minimumBedrooms = bedrooms
  //     state.value.advancedFilters.maximumBedrooms = null
  //   } else {
  //     state.value.advancedFilters.minimumBedrooms = null
  //   }
  // })
  // watch(() => state.value.advancedFilters.bathrooms, (bathrooms) => {
  //   if (bathrooms) {
  //     state.value.advancedFilters.minimumBathrooms = bathrooms
  //     state.value.advancedFilters.maximumBathrooms = null
  //   } else {
  //     state.value.advancedFilters.minimumBathrooms = null
  //   }
  // })
  // watch(() => state.value.baseFilters.date, (date) => {
  //   // console.log('watcher 3')
  //   // console.log(date)
  // },{deep: true})

  const urlParams = new URLSearchParams(window.location.search);
  urlParams.forEach((value, key) => {
    switch (key) {
      case 'destinationIds': {
        const arr = value.split(' ')
        state.value.baseFilters.destinations = arr.map((el) => parseInt(el))
        break;
      }
      case 'destinationKey': {
        state.value.baseFilters.destinationKey= value;
        break;
      }
      case 'checkin': {
        const ds = DateTime.fromFormat(value, 'yyyy-MM-dd',{zone: 'UTC'})
        state.value.baseFilters.date.start = ds
        state.value.ccalendar.month = ds.month
        state.value.ccalendar.year = ds.year
        break;
      }
      case 'checkout': {
        const de = DateTime.fromFormat(value, 'yyyy-MM-dd',{zone: 'UTC'})
        state.value.baseFilters.date.end = de
        break;
      }
      case 'adults': {
        state.value.baseFilters.guests.adults = parseInt(value)
        break;
      }
      case 'children': {
        state.value.baseFilters.guests.children = parseInt(value)
        break;
      }
      case 'pets': {
        state.value.baseFilters.guests.pets = parseInt(value)
        break;
      }
      case 'petFriendly': {
        state.value.advancedFilters.petFriendly = true
        break;
      }
      case 'privatePool': {
        state.value.advancedFilters.privatePool = true
        break;
      }
      case 'pool': {
        state.value.advancedFilters.pool = true
        break;
      }
      case 'lodgingTypeIds': {
        const arr = value.split(' ')
        state.value.advancedFilters.lodgingTypeIds = arr.map((el) => parseInt(el))
        break;
      }
      case 'lodgingTypeIds[]':{
        state.value.advancedFilters.lodgingTypeIds.push(parseInt(value));
        break;
      }
      case 'amenityIds': {
        const arr = value.split(' ')
        state.value.advancedFilters.amenityIds = arr.map((el) => parseInt(el))
        break;
      }
      case 'amenityKeys': {
        const arr = value.split(' ')
        state.value.advancedFilters.amenityKeys = arr.map((el) => el)
        break;
      }
      case 'amenityKeys[]':{
        state.value.advancedFilters.amenityKeys.push(value);
        break;
      }
      case 'locationIds': {
        const arr = value.split(' ')
        state.value.advancedFilters.locationIds = arr.map((el) => parseInt(el))
        break;
      }
      case 'beds': {
        state.value.advancedFilters.minimumBeds = parseInt(value)
        state.value.advancedFilters.maximumBeds = null
        break;
      }
      case 'minimumBeds': {
        state.value.advancedFilters.minimumBeds = parseInt(value)
        break;
      }
      case 'maximumBeds': {
        state.value.advancedFilters.maximumBeds = parseInt(value)
        break;
      }
      case 'bedrooms': {
        state.value.advancedFilters.minimumBedrooms = parseInt(value)
        state.value.advancedFilters.maximumBedrooms = null
        break;
      }
      case 'minimumBedrooms': {
        state.value.advancedFilters.minimumBedrooms = parseInt(value)
        break;
      }
      case 'maximumBedrooms': {
        state.value.advancedFilters.maximumBedrooms = parseInt(value)
        break;
      }
      case 'bathrooms': {
        state.value.advancedFilters.minimumBathrooms = parseInt(value)
        state.value.advancedFilters.maximumBathrooms = null
        break;
      }
      case 'minimumBathrooms': {
        state.value.advancedFilters.minimumBathrooms = parseInt(value)
        break;
      }
      case 'maximumBathrooms': {
        state.value.advancedFilters.maximumBathrooms = parseInt(value)
        break;
      }
      case 'deal': {
        state.value.advancedFilters.deal = true
        break;
      }
      case 'new': {
        state.value.advancedFilters.new = true
        break;
      }
      case 'display': {
        state.value.search.display = value
        break;
      }
    }
  })

  watch(() => state.value.baseFilters.destinations, (dest, oldDest) => {
    if (!isEqual(dest, oldDest)) {
      state.value.map.suspendSearch = true
      state.value.advancedFilters.area = null
    }
  }, { deep: true })
  watch(() => state.value.advancedFilters.locationIds, (loc, oldLoc) => {
    if (!isEqual(loc, oldLoc)) {
      state.value.map.suspendSearch = true
      state.value.advancedFilters.area = null
    }
  }, { deep: true })

  return {
    state
  }
})
